module.exports = __webpack_public_path__ + "media/images/OPL 3-7f57a29d4de1b1dc6e5335c87047b880.png";